import React, {useEffect, useRef} from 'react'
import {CertificateCanvasView} from './CertificateCanvasView'
import {buildCertificatePdf, saveCertificatePdf} from './exportCertificatePdf'
import {CERT_ARTBOARD_H, CERT_ARTBOARD_W, CertificateRenderModel} from './certificateTypes'

type Props = {
  model: CertificateRenderModel
  onFinished: (succeeded: boolean) => void
}

export const CertificatePdfExporter: React.FC<Props> = ({model, onFinished}) => {
  const rootRef = useRef<HTMLDivElement>(null)
  const onFinishedRef = useRef(onFinished)
  onFinishedRef.current = onFinished

  useEffect(() => {
    let cancelled = false
    const root = rootRef.current
    if (!root) return

    buildCertificatePdf(
      root,
      model.document.width || CERT_ARTBOARD_W,
      model.document.height || CERT_ARTBOARD_H
    )
      .then((pdf) => {
        if (cancelled) return
        saveCertificatePdf(pdf, model.fileName)
        onFinishedRef.current(true)
      })
      .catch((error) => {
        console.error(error)
        if (!cancelled) onFinishedRef.current(false)
      })

    return () => {
      cancelled = true
    }
  }, [model])

  return (
    <div className='certificate-pdf-export' aria-hidden='true'>
      <CertificateCanvasView ref={rootRef} document={model.document} context={model.context} />
    </div>
  )
}
